import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-59" data-mp="3f2n9g4plp4u6">
      {eyebrow && <p className={`text-xs font-extrabold uppercase tracking-[0.14em] ${dark ? 'text-gold' : 'text-teal'}`} data-id="element-60" data-mp="3k1865u5n96dv">
          {eyebrow}
        </p>}
      <h2 className={`mt-2 text-[26px] font-extrabold leading-[1.18] tracking-tight md:text-4xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-61" data-mp="bmpw5mw57grm">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed md:text-lg ${dark ? 'text-white/80' : 'text-navy/70'}`} data-id="element-62" data-mp="6tdg415j4iah">
          {subtitle}
        </p>}
    </div>;
}